import { TChangeDishPositionSelectedItem, TTypeOfChangeDishPositionModalWindow } from './changeDishPositionContext';
import { IItemForGetShortInfo, IDishPositionItem } from 'types';

export enum ChangeDishPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	SET_ID_SUB_CATEGORY = 'SET_ID_SUB_CATEGORY',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	REORDER_ITEMS = 'REORDER_ITEMS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
}

interface ISetIDCustomer {
	type: ChangeDishPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: TChangeDishPositionSelectedItem;
	};
}

interface ISetIDRestaurant {
	type: ChangeDishPositionActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: TChangeDishPositionSelectedItem;
	};
}

interface ISetIDCategory {
	type: ChangeDishPositionActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: TChangeDishPositionSelectedItem;
	};
}

interface ISetIDSubCategory {
	type: ChangeDishPositionActionTypes.SET_ID_SUB_CATEGORY;
	payload: {
		IDSelectedSubCategory: TChangeDishPositionSelectedItem;
	};
}

interface IResetSelectedControls {
	type: ChangeDishPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeDishPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IDishPositionItem[];
	};
}

interface IReorderItems {
	type: ChangeDishPositionActionTypes.REORDER_ITEMS;
	payload: {
		newOrder: IDishPositionItem[];
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeDishPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfChangeDishPositionModalWindow;
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: ChangeDishPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisible: boolean;
		isApplyToOne: boolean;
		selectedAdditionalRestaurants: string[];
	};
}

interface IToggleApplyToOne {
	type: ChangeDishPositionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: ChangeDishPositionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		additionalRestaurants: string[];
	};
}

interface ISetFetchedRestaurants {
	type: ChangeDishPositionActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IItemForGetShortInfo[];
	};
}

export type TChangeDishPositionActions =
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDCategory
	| ISetIDSubCategory
	| IResetSelectedControls
	| ISetPositionsData
	| IReorderItems
	| IChangeTypeOfModalWindow
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| ISetFetchedRestaurants;
